import React from 'react';
import '../../slider.css';

export const ImageRows = ({imageSources, cb}) =>{
  return <>
    {imageSources.map((src, index) => (
      index % 2 === 0 && (
        <ImageRow
          key={index}
          cb={cb}
          img1={imageSources[index]}
          img2={imageSources[index + 1]}
        />
      )
  ))}
 </>
}

export const ImageRow = ({ img1, img2, cb}) => (
  <div className="flexContainer">
    <img
      alt={""}
      src={img1}
      className="imageStyle"
      onClick={()=>cb(img1)}
    />
    {img2 && <div className="spacer"></div>}
    {img2 && <img
      alt={""}
      src={img2}
      className="imageStyle"
      onClick={()=>cb(img2)}
    />}
  </div>
);


export const TopArea = ({imgPath, name, subtitle}) =>{
  return <>
    {imgPath &&
     <div className="pin-top-img">
      <img
      alt={name}
      src={imgPath}
      width={"100%"}
      />
    </div>}
    <div style={{padding:"0px 30px"}} >
        <div style={{marginTop:"25px", display:"flex"}}>
          <div>
            <b style={{fontSize:"2rem", color:"#8c662f",  fontFamily: 'AppleSDGothicNeo-SemiBold'}}>{name}</b>
          </div>
          {subtitle && <>
          <div style={{width:"5px", height:"35px", backgroundColor:"#f57600", marginLeft:"15px", marginTop:"8px"}}></div>
          </>
          }
        </div>
        <div style={{fontSize:"1.3rem", color:"#4f5456",  fontFamily: 'AppleSDGothicNeo-Medium', marginTop:"8px"}}>{subtitle}</div>
    </div>
 </>
}

export default ImageRows;